module.exports = __webpack_public_path__ + "static/media/toilet-paper-alt.93db8e1e.svg";